export default {
    mounted(el, binding, vnode) {
        vnode.ro = new ResizeObserver(binding.value)
        vnode.ro.observe(el)
    },
    beforeUnmount(el, binding, vnode) {
        // if (vnode?.ro) {
        //     vnode.ro.unobserve(el)
        // }
    }
}